export const globalValues = {
    DATA_ENC_KEY: "tyobe@gklab"
  };